var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"odr-main-button",class:( _obj = {
            'odr-main-button_clean': _vm.clean ==='true',
            'odr-main-button_rounded': _vm.rounded ==='true'
        }, _obj[("odr-main-button_background-color-" + _vm.color)] = _vm.color, _obj ),style:(_vm.style),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }